module.exports = __webpack_public_path__ + "img/org-time-zone.2647853a.png";